var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocal = function SvgLocal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .75A5.251 5.251 0 0 0 .75 6c0 1.969.63 2.57 4.13 8.148.52.82 1.695.82 2.214 0 3.5-5.578 4.157-6.18 4.157-8.148C11.25 3.102 8.87.75 6 .75Zm0 12.688C2.5 7.859 2.064 7.503 2.064 6c0-2.16 1.75-3.938 3.938-3.938C8.16 2.063 9.938 3.84 9.938 6c0 1.504-.437 1.805-3.937 7.438ZM3.814 6a2.16 2.16 0 0 0 2.188 2.188A2.176 2.176 0 0 0 8.188 6a2.194 2.194 0 0 0-2.187-2.188c-1.23 0-2.188.985-2.188 2.188Z"
  })));
};
export default SvgLocal;